<template>
  <Section id="step-five" type="dark">
    <Counter>5</Counter>
    <Heading>Import karma points</Heading>
    <Description>
      <slot />
    </Description>
    <Action>
      <a class="btn btn--primary" :class="{'is-disabled': disabled}" href="https://my.slack.com/services/import/slack" target="_blank">IMPORT KARMA</a>
    </Action>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Counter from './UI/Counter'
  import Action from './UI/Action'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Counter,
      Action,
    },
    props: ['disabled'],
  }
</script>

<style lang="scss" scoped>
  
</style>
